<template>
  <div id="summary">
    <touch @swipedown="prev">
      <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
      <div class="honor">
        <h4>奖  状</h4>
        <p><strong class="name">{{ nickCutOff(name) }}</strong>同志在二零一七年度英语学习运动中取得显著成绩，被评为先进个人，特授奖状！</p>
        <p><small>组织对你的年度批语：</small><strong>{{ comment }}</strong></p>
      </div>
      <div class="people">
        <webp-image src="https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/people-p0BtVn9f.png" />
        <touch v-if="shared" class="share download" @tap="download"></touch>
        <touch v-else class="share" @tap="share"></touch>
        <div class="logo">
          <webp-image src="https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/logo-VL9l2bKz.png" alt="logo" />
        </div>
      </div>
    </touch>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import actions from '@/store/action-types'

  import WebpImage from '@/components/common/WebpImage'

  export default {
    name: 'page-summary',
    computed: {
      ...mapState({
        musicPlaying: state => state.musicPlaying,
        name: state => state.data.nick,
        ptLevel: state => state.data.reports.ptLevel,
        data: state => state.data,
        shareId: state => state.share.shareId
      }),
      shared () {
        return !!this.$store.state.urlParams.shareId
      },
      comment () {
        const comments = [
          '革命尚未成功，同志仍需努力！',
          '从群众中来，到精英中去',
          '下一代社会主义接班人就是你！',
          '好好学习，天天向上',
          '一切拖延症都是纸老虎！',
          '学习才是硬道理！',
          '榜样的力量是无穷的！'
        ]
        return comments[this.ptLevel]
      }
    },
    created () {
      this.$track.sendPageTrack('report_result')
      this.$store.dispatch(actions.post.SHARED_CONTENTS, {
        targetType: 'custom',
        extra: this.data
      })
    },
    methods: {
      prev () {
        history.back()
      },
      share () {
        this.$track.sendActionTrack('report_result', 'click_share_report', {
          type: 'share'
        })
        this.$wxShare.share({
          title: '给各位汇报一下，这是我的年度成绩单',
          desc: '最后一页看哭了......',
          link: `${location.origin + location.pathname}?shareId=${this.shareId}`,
          imgUrl: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/share-ZItE5r5b.jpg'
        })
      },
      download () {
        this.$track.sendActionTrack('report_result', 'click_share_report', {
          type: 'download'
        })
        setTimeout(() => {
          location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.liulishuo.engzo&ckey=CK1384431395512'
        }, 300)
      },
      playOrPause () {
        this.$emit('playOrPauseBgMusic')
      },
      nickCutOff (nick) {
        return nick.length > 8 ? `${nick.substring(0, 8)}...` : nick
      }
    },
    components: {
      WebpImage
    }
  }
</script>


<style lang="scss">
  $honor: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/jiangzhuang-umaKzedt.png';
  $share: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/share-5tUoykxM.png';
  $shared: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/share-KQU4LwMD.jpg';

  #summary {
    position: relative;
    height: 100%;
    padding-top: 150px;
    box-sizing: border-box;
    .honor {
      @include bg-image-cover($honor);
      position: relative;
      z-index: 2;
      width: 674px;
      height: 466px;
      margin-left: 38px;
      padding-top: 120px;
      padding-left: 100px;
      padding-right: 100px;
      box-sizing: border-box;
      animation: zoomIn 0.6s ease-in-out 0.3s;
      h4 {
        font-size: 60px;
        color: $lightRed;
        line-height: 72px;
        text-align: center;
      }
      p {
        font-size: 25px;
        color: $lightRed;
        strong {
          color: $darkBlue;
        }
        small {
          font-size: 15px;
        }
      }
      .name {
        font-family: Helvetica,Tahoma,Arial,'PingFang SC','Microsoft YaHei','Hiragino Sans GB',SimSun,Heiti,sans-serif;
      }
    }
    .people {
      position: absolute;
      bottom: 20%;
      z-index: 4;
      margin-left: 257px;
      margin-right: 257px;
      animation: fadeUpIn 0.5s ease-in;
      .share {
        @include bg-image-cover($share);
        position: absolute;
        bottom: -60px;
        left: -108px;
        width: 453px;
        height: 115px;
        animation: heartbeat 0.75s 0.5s infinite ease-in-out;
        animation-direction: alternate;
        &.download {
          background-image: url($shared);
        }
      }
      .logo {
        position: absolute;
        left: 50%;
        bottom: -150px;
        z-index: 6;
        width: 209px;
        height: 50px;
        margin-left: -105px;
      }
    }
  }
  body[data-webp='support'] {
    #summary {
      .honor {
        background-image: url($honor + '?imageMogr2/format/webp');
      }
      .people {
        .share {
          background-image: url($share + '?imageMogr2/format/webp');
          &.download {
            background-image: url($shared + '?imageMogr2/format/webp');
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Summary.vue